import Vue from 'vue';
import previewImage from '../components/ui/preview-image/index';

Vue.use(previewImage);
